<!-- 平台管理 - 营销员任务清单 -->
<template>
    <div>
        <admin-main-header></admin-main-header>

        <div class="admin-main-body">
            <div class="admin-content" :style="{minHeight: adminContentMinHeight + 'px'}">
                <div class="admin-content-title el-clearfix">
                    <span class="el-title-bar"> 我的分销任务清单</span>
                </div>
                <div class="admin-content-main">
                    <div class="el-search-form">
                        <el-form ref="taskSummaryQueryForm" :model="taskSummaryQueryForm">
                            <el-row :gutter="20">
                                <el-col :span="6" :offset="3">
                                    <el-form-item prop="taskConsumeOrgId">
                                        <el-select v-model="taskSummaryQueryForm.taskConsumeOrgId" clearable filterable :filter-method="filterAllOrgs" @visible-change="resetOrgSelectFilterQuery" placeholder="服务公司" class="el-full-width">
                                            <el-option v-for="item in taskSummaryQueryOrgSelectOptions" :key="item.orgId" :label="item.orgName" :value="item.orgId" class="org-select-option">
                                                <span class="option-left">{{ item.orgCode }}</span>
                                                <span class="option-right">{{ item.orgName }}</span>
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item prop="distributeDateRange">
                                        <el-date-picker style="width:100%;" v-model="taskSummaryQueryForm.distributeDateRange" clearable type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" start-placeholder="服务日期(开始)" end-placeholder="服务日期(结束)">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item class="el-align-center">
                                        <el-button @click="resetTaskSummaryQueryForm" icon="fas fa-undo">重 置</el-button>&nbsp;&nbsp;
                                        <el-button type="primary" @click="queryTaskSummaryList(1000)" icon="fas fa-search">查 询</el-button>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                    <div class="el-search-list">
                        <el-table ref="taskSummaryTable" v-loading="taskSummaryQueryLoading" element-loading-text="拼命加载中..." element-loading-custom-class="el-loading-mask-opacity" :class="{loading: taskSummaryQueryLoading}" :data="taskSummaryList" :default-sort="taskSummaryQuerySort" @sort-change="onTaskSummaryQuerySortChange" style="width:100%;" class="el-table-overflow-x-hidden" empty-text="暂无数据">
                            <el-table-column label="#" type="index" width="50"></el-table-column>
                            <el-table-column label="任务ID" prop="taskId" width="160" align="center" sortable></el-table-column>
                            <el-table-column label="服务对象" prop="serviceTargetName" width="120" align="center"></el-table-column>
                            <el-table-column label="服务标的" prop="targetPlateNumber" width="100" align="center"></el-table-column>
                            <el-table-column label="服务金额" prop="serviceAmounts" width="100" align="center">
                                <template slot-scope="scope">
                                    <el-popover placement="top" trigger="hover">
                                        <ul class="task-service-details">
                                            <li v-for="(serviceDetail, index) in scope.row.taskServiceDetails" :key="index">
                                                <span class="name">{{serviceDetail.serviceName}}</span>：<span>{{serviceDetail.servicePrice}}{{serviceDetail.priceUnit}} x {{serviceDetail.serviceCount}}</span>
                                            </li>
                                        </ul>
                                        <el-button type="text" slot="reference">{{scope.row.serviceAmounts}}</el-button>
                                    </el-popover>
                                </template>
                            </el-table-column>
                            <el-table-column label="服务公司" prop="taskConsumeOrgName" align="center"></el-table-column>
                            <el-table-column label="团队长" prop="leaderStaffName" width="180" align="center">
                                <template slot-scope="scope">
                                    <div>{{scope.row.leaderStaffName}}</div>
                                    <div class="idcard">{{scope.row.leaderStaffIdcard}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column label="服务人员" prop="serviceStaffName" width="180" align="center">
                                <template slot-scope="scope">
                                    <div>{{scope.row.serviceStaffName}}</div>
                                    <div class="idcard">{{scope.row.serviceStaffIdcard}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column label="服务日期" prop="distributeDate" width="120" align="center"></el-table-column>
                        </el-table>
                    </div>
                    <div class="el-search-pager">
                        <el-pagination background v-show="showTaskSummaryQueryPager" @current-change="onTaskSummaryQueryCurrentPageChange" :current-page.sync="taskSummaryQueryForm.currentPage" :page-size="taskSummaryQueryForm.pageSize" layout="prev, pager, next, total, slot" :total="taskSummaryQueryTotal">
                            <div class="el-pagination-pagesize">
                                <span class="first">每页显示</span>
                                <el-button-group>
                                    <el-button :class="{active: taskSummaryQueryForm.pageSize == 10}" @click="onTaskSummaryQueryPageSizeChange(10);">10</el-button>
                                    <el-button :class="{active: taskSummaryQueryForm.pageSize == 20}" @click="onTaskSummaryQueryPageSizeChange(20);">20</el-button>
                                    <el-button :class="{active: taskSummaryQueryForm.pageSize == 50}" @click="onTaskSummaryQueryPageSizeChange(50);">50</el-button>
                                    <el-button :class="{active: taskSummaryQueryForm.pageSize == 100}" @click="onTaskSummaryQueryPageSizeChange(100);">100</el-button>
                                </el-button-group>
                                <span class="last">条</span>
                            </div>
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defaultApiErrorHandler, PLATFORM_API } from '@/api.js';
import { mapSort } from '@/utils.js';

export default {
    name: 'SalesmanTaskSummary',
    data() {
        return {
            submiting: false,
            allOrgList: [],
            orgSelectFilterQuery: '',
            leaderStaffQueryLoading: false,
            leaderStaffQuerySelectOptions: [],

            taskSummaryList: [],
            taskSummaryQueryLoading: false,
            taskSummaryQuering: false,
            taskSummaryQueryForm: {
                taskConsumeOrgId: '',
                distributeDateRange: [],
                startDistributeDate: '',
                endDistributeDate: '',
                fetchDetails: true,
                pageSize: 10,
                currentPage: 1
            },
            taskSummaryQueryTotal: 0,
            taskSummaryQuerySort: {
                prop: 'createTime',
                order: 'descending'
            }
        };
    },
    computed: {
        loginUser() {
            return this.$store.state.loginUserAllData.loginUser;
        },
        showTaskSummaryQueryPager() {
            if (this.taskSummaryQuering || this.taskSummaryQueryTotal == 0) {
                return false;
            } else {
                return true;
            }
        },
        taskSummaryQueryOrgSelectOptions() {
            if (this.orgSelectFilterQuery) {
                return this.allOrgList.filter(org => {
                    if (org.orgCode.indexOf(this.orgSelectFilterQuery) > -1) {
                        return true;
                    }
                    if (org.orgName.indexOf(this.orgSelectFilterQuery) > -1) {
                        return true;
                    }
                    return false;
                });
            } else {
                return this.allOrgList.filter(org => true);
            }
        }
    },
    created() {},
    mounted() {
        this.loadAllOrgList();
        this.queryTaskSummaryList(1000);
    },
    methods: {
        filterAllOrgs(value) {
            this.orgSelectFilterQuery = value;
        },
        loadAllOrgList() {
            let url = PLATFORM_API.of('/api/platform/upms/org/all');
            this.$http
                .get(url)
                .then(response => {
                    let result = response.data;
                    if (result.success) {
                        this.allOrgList = result.data;
                    }
                })
                .catch(defaultApiErrorHandler);
        },
        resetOrgSelectFilterQuery() {
            this.orgSelectFilterQuery = '';
        },
        clearLeaderStaffQuerySelectOptions() {
            this.leaderStaffQuerySelectOptions = [];
        },
        queryTaskSummaryList(loading) {
            this.taskSummaryQueryForm.currentPage = 1;
            this.doQueryTaskSummaryList(loading);
        },
        doQueryTaskSummaryList(loading) {
            this.taskSummaryQuering = true;
            if (loading) {
                this.taskSummaryQueryLoading = true;
            }
            setTimeout(() => {
                this.taskSummaryQueryForm.startDistributeDate = this.taskSummaryQueryForm.distributeDateRange[0];
                this.taskSummaryQueryForm.endDistributeDate = this.taskSummaryQueryForm.distributeDateRange[1];
                let params = Object.assign(
                    {},
                    this.taskSummaryQueryForm,
                    mapSort(this.taskSummaryQuerySort)
                );
                delete params.distributeDateRange;
                this.$http
                    .get(
                        PLATFORM_API.of('/api/platform/visp/taskservice/list'),
                        {
                            params: params
                        }
                    )
                    .then(response => {
                        let result = response.data;
                        if (result.success) {
                            this.taskSummaryList = result.data;
                            this.taskSummaryQueryTotal = result.totalRowCount;
                        } else {
                            this.taskSummaryList = [];
                            this.taskSummaryQueryTotal = 0;
                            this.$message.error(result.message);
                        }
                    })
                    .catch(error => {
                        this.taskSummaryList = [];
                        this.taskSummaryQueryTotal = 0;
                        defaultApiErrorHandler.call(this, error);
                    })
                    .then(() => {
                        if (loading) {
                            this.taskSummaryQueryLoading = false;
                        }
                        this.taskSummaryQuering = false;
                    });
            }, loading);
        },
        resetTaskSummaryQueryForm() {
            this.$refs.taskSummaryQueryForm.resetFields();
        },
        onTaskSummaryQuerySortChange(parameter) {
            if (
                this.taskSummaryQuerySort.prop != parameter.prop ||
                this.taskSummaryQuerySort.order != parameter.order
            ) {
                this.taskSummaryQuerySort.prop = parameter.prop;
                this.taskSummaryQuerySort.order = parameter.order;
                this.queryTaskSummaryList(1000);
            }
        },
        onTaskSummaryQueryPageSizeChange(pageSize) {
            this.taskSummaryQueryForm.pageSize = pageSize;
            this.queryTaskSummaryList(1000);
        },
        onTaskSummaryQueryCurrentPageChange(currentPage) {
            this.taskSummaryQueryForm.currentPage = currentPage;
            this.doQueryTaskSummaryList(1000);
        }
    }
};
</script>
<style lang="scss">
.idcard {
    color: $--color-gray;
}
.task-service-details {
    list-style-position: inside;
    padding: 5px 15px 5px 5px;
    .name {
        color: $--color-primary;
    }
}
</style>